import { render, staticRenderFns } from "./LuckyNumberMB.vue?vue&type=template&id=37f577b2&scoped=true&"
import script from "./LuckyNumberMB.vue?vue&type=script&lang=js&"
export * from "./LuckyNumberMB.vue?vue&type=script&lang=js&"
import style0 from "./LuckyNumberMB.vue?vue&type=style&index=0&id=37f577b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f577b2",
  null
  
)

export default component.exports